import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { useCount } from 'modules/quickActionsMenu/hooks';
import { SetCount } from 'modules/quickActionsMenu/types';
import { User16 } from 'ui/icons/aurora/16px/studio';
import { Spinner } from 'ui/spinner';
import { Item } from '../Item';
import { CommandGroup, CommandLoading, EmptyState } from '../Styled';
import { useUserSearch } from './useUserSearch';

export const USER_SEARCH_TEXT = {
  heading: 'Users',
  emptyStateMessage: 'No matching results',
  zeroStateMessage: 'Type a user’s email or ID to search',
};

const { emptyStateMessage, heading, zeroStateMessage } = USER_SEARCH_TEXT;

export const UserSearch = ({ setCount }: { setCount: SetCount }) => {
  const { navigate, debouncedSearchTerm } = useQuickActionsMenuContext();
  const { isLoading, users } = useUserSearch();
  useCount({ count: users.length, setCount });

  if (isLoading) {
    return (
      <CommandLoading>
        <Spinner />
      </CommandLoading>
    );
  }

  return (
    <>
      {users.length === 0 ? (
        <EmptyState>
          {debouncedSearchTerm.length === 0 ? zeroStateMessage : emptyStateMessage}
        </EmptyState>
      ) : (
        <CommandGroup heading={heading}>
          {users.map((user: string) => (
            <Item
              Icon={<User16 />}
              key={user}
              name={user}
              onSelect={() =>
                navigate({
                  id: user,
                  pageName: 'User details page ',
                  path: `/users/profiles/${encodeURI(user)}`,
                })
              }
              value={user}
            />
          ))}
        </CommandGroup>
      )}
    </>
  );
};
